"use client"

import clsx from "clsx"
import React from "react"

import { RichTextContent } from "@/app/impact/_types/impact"
import { ContentfulRichText } from "@/helpers/ContentfulRichText"
import { mapContentfulToButtonProps } from "@/helpers/utils"

import Button, { ContentfulButton } from "../../Button"

export interface StatToutProps extends React.ComponentPropsWithoutRef<"div"> {
  title: string
  description: RichTextContent
  button?: ContentfulButton
}

const StatTout: React.FC<StatToutProps> = ({
  title,
  description,
  button,
  className,
  ...rest
}) => (
  <div
    className={clsx("p-4 col-span-full md:col-span-2 lg:col-span-4", className)}
    {...rest}
  >
    <h3 className="headline5 lg:headlin4 text-gray-90">{title}</h3>
    <div className="body4 text-gray-90">
      {description?.json ? (
        <ContentfulRichText document={description.json as any} />
      ) : null}
    </div>
    {button && (
      <div className="mt-4">
        <Button {...mapContentfulToButtonProps(button)} target="_blank" />
      </div>
    )}
  </div>
)

export default StatTout
